import {
  IBestOptionSectionIndustries,
  IOutsourcingToDedicatedTeamsSection,
} from '@components/services/dedicated-teams/dedicated-teams.state';
import template from '@components/services/services.module.scss';
import OutsourcingToDedicatedTeams from '@components/services/dedicated-teams/sections/outsourcing-to-dedicated-teams/outsourcing-to-dedicated-teams';
import style from './best-option.module.scss';
import Image from 'next/image';

interface IBestOptionSectionProps {
  title: string;
  description: string;
  industriesTitle: string;
  industries: IBestOptionSectionIndustries[];
  card: IOutsourcingToDedicatedTeamsSection;
}

const BestOptionSection = ({ title, description, industriesTitle, industries, card }: IBestOptionSectionProps) => {
  return (
    <section
      className={`${template.section} ${template.section_light} ${template.section} ${style.manage_section} ${style.section}`}
    >
      <div className={`${template.container}  ${style.benefits}`}>
        <div
          className={`${template.title} ${template.title_large} ${template.mb20} ${template.text_align_c} ${style.benefits__title}`}
        >
          <h2 className={`${template.title_large}`}>{title}</h2>
        </div>
        <div
          className={`${template.mb40}  ${style.description} ${template.text} ${template.text_color_main} ${template.text_small} ${template.text_align_c} ${template.fw400}`}
        >
          {description}
        </div>
      </div>
      <div className={`${template.container} ${template.container_large} ${style.option__industries}`}>
        <div
          className={`${template.title} ${template.title_large} ${template.mb20} ${template.text_align_c} ${style.option__title}`}
        >
          {industriesTitle}
        </div>
        <div className={`${style.option__industries_wrapper}`}>
          {industries.map((item: IBestOptionSectionIndustries, index: number) => {
            return (
              <div className={`${style.option__item}`} key={index}>
                <div className={`${style.option__item__image} ${template.mr20}`}>
                  <Image src={item.iconSrc} alt={item.title} layout="fill" objectFit="contain" />
                </div>
                <div
                  className={`${template.text} ${template.text_small} ${template.text_color_main} ${style.option__item__header}`}
                >
                  {item.title}
                </div>
                <div
                  className={`${style.option__item__text} ${template.text} ${template.text_small} ${template.text_align_l} ${template.text_color_main} ${template.fw400}`}
                >
                  {item.text}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div
        className={`${template.container} ${style.block} ${template.flex} ${template.flex_justify_content_space_between}`}
      >
        <OutsourcingToDedicatedTeams imageSrc={card.imageSrc} title={card.title} text={card.text} list={card.list} />
      </div>
    </section>
  );
};

export default BestOptionSection;
